export default function bulkReplacePlaceholders(text: any, placeholders: any) {
    for (const placeholder in placeholders) {
        const regex = new RegExp(`{{${placeholder}}}`, 'g');
        text = text.replace(regex, (placeholders[placeholder] === '') ? `{{${placeholder}}}` : placeholders[placeholder]);
    }

    return text;
}